import React from 'react';
import {useTranslation} from 'react-i18next';

import {Number, Stack} from '@edna/components/primitives';

import Subject from 'src/components/Subject';
import {TSubject} from 'src/constants';

type TNumberedSubjectProps = {
  className?: string;
  subject: TSubject;
  number: number;
  active?: boolean;
};

const NumberedSubject = React.memo<TNumberedSubjectProps>(
  ({className, subject, number, active = false}) => {
    const {t} = useTranslation();
    const name = subject?.name ?? t('NumberedSubject:channel', {count: number});

    return (
      <Stack align="center" direction="ROW" size="2" className={className}>
        <Number size="XL" isActive={active}>
          {number}
        </Number>
        {subject && <Subject type={subject.type} name={name} />}
      </Stack>
    );
  },
);

NumberedSubject.displayName = 'NumberedSubject';

export default NumberedSubject;
